import { createContext } from 'react';

import { DEFAULT_HONEYCOMB_LABELS_DISPLAY } from '../constants.js';
import type { HoneycombLabelsDisplay } from '../types/honeycomb.js';

export const HoneycombLabelsDisplayContext =
  createContext<HoneycombLabelsDisplay>(DEFAULT_HONEYCOMB_LABELS_DISPLAY);
